export default __webpack_public_path__ + "static/media/dao-info-img.74dc57ca.svg";